import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

import {
  updateIndexPage,
  updateDetailPage,
  updateAreaOnePage,
  updateAreaTwoPage,
  updateMenuOpen
} from '../store/globalReducer';

import titleImg from '../assets/img/common/title_header_pc.svg';
import titleHorImg from '../assets/img/common/title_header_hor.svg';
import logoImg from '../assets/img/common/logo_red.svg';
import iconBack from '../assets/img/common/icon_back.svg';
import '../assets/scss/components/header.scss';

function Subtitle({ textVal }) {
  return (
    <motion.div
      className="header__subtitle"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}>
      <p>{textVal}</p>
    </motion.div>
  )
}

export default function Header() {
  const location = useLocation();
  const dispatch = useDispatch();

  const isIndexPage = useSelector(state => state.global.isIndexPage);
  const isAreaOnePage = useSelector(state => state.global.isAreaOnePage);
  const isAreaTwoPage = useSelector(state => state.global.isAreaTwoPage);
  const isDetailPage = useSelector(state => state.global.isDetailPage);

  const isMenuOpen = useSelector(state => state.global.isMenuOpen);
  const templeList = useSelector(state => state.temples.templeData);

  useEffect(() => {
    dispatch(updateIndexPage(false));
    dispatch(updateAreaOnePage(false));
    dispatch(updateAreaTwoPage(false));
    dispatch(updateDetailPage(false));
  }, [location]);

  const handleTriggerClick = e => {
    e.preventDefault();
    dispatch(updateMenuOpen(true));
  }

  const renderSubtitle = () => {
    if (isIndexPage) {
      return (<Subtitle textVal="全体マップ" />);
    }
    else if (isAreaOnePage) {
      return (<Subtitle textVal="桂浜" />);
    }
    else if (isAreaTwoPage) {
      return (<Subtitle textVal="佐川" />);
    }
    else {
      return false;
    }
  }

  return (
    <header className={`header ${isDetailPage ? 'is-detail' : ''}`}>
      <div className="header__inner">
        <div className="header__container">
          <div className="header__top">
            <div className="header__title">
              <div className='header__title-inner'>
                <img className="header__title-vert" src={titleImg} alt="牧野マップ with 桂浜" />
                <img className="header__title-hor" src={titleHorImg} alt="牧野マップ with 桂浜" />
              </div>
            </div>
            <AnimatePresence>{renderSubtitle()}</AnimatePresence>
          </div>
          <div className="header__bottom">
            <AnimatePresence>
              {(isAreaOnePage || isAreaTwoPage) && (
                <motion.div
                  className="header__back"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}>
                  <Link to={`/`}>
                    <i><img src={iconBack} alt="" /></i>
                    <span>Back</span>
                  </Link>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <motion.div
            className="header__menu"
            initial={{ x: '0%' }}
            animate={(isMenuOpen && !isDetailPage)
              ? { x: '100px', transition: { ease: 'easeOut', duration: 0.3 } }
              : { x: '0px', transition: { ease: 'easeOut', duration: 0.3, delay: 0.35 } }}>
            <a href="#" onClick={handleTriggerClick}><span></span><span></span></a>
          </motion.div>
        </div>
      </div>
    </header>
  );
}